import React from 'react';
import { Grid, Typography, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';

/**
 * Component displaying summary for DNA based risk.
 *
 * @param {Component properties} props
 */
export default function MockedDnaRiskExplanation(props) {
  const { t } = useTranslation();

  const useStyles = makeStyles(theme => ({
    title: {
      paddingTop: '17px',
    },
    paragraph: {
      color: '#222222',
      fontSize: '15px',
      lineHeight: '20px',
    },
    sectionBullet: {
      marginTop: '8px',
      color: '#33b0ce',
    },
  }));

  const classes = useStyles();

  return (
    <>
      <Box mt={2}>
        <Typography style={{ fontSize: '15px', lineHeight: '20px' }}>
          {t('reporting.common.buy.paragraph2')}
        </Typography>
      </Box>
      <Box>
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="flex-start"
          style={{ marginTop: '14px' }}
        >
          {t('reporting.myAssessment.dnaTraitsList', {
            returnObjects: true,
          }).map((trait, ix) => {
            return (
              <Grid
                item
                xs={props.isDesktop ? 6 : 12}
                style={{
                  paddingLeft: props.isDesktop && ix % 2 === 1 ? '20px' : 0,
                }}
              >
                <ul
                  style={{
                    paddingLeft: '20px',
                    marginTop: '4px',
                    marginBottom: '4px',
                  }}
                >
                  <li className={classes.sectionBullet}>
                    <Typography
                      variant={'body1'}
                      className={classes.paragraph}
                      key={ix}
                      style={{
                        fontWeight: 'normal',
                      }}
                    >
                      {trait}
                    </Typography>
                  </li>
                </ul>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </>
  );
}
